import styled from "styled-components";
import appTheme from "../../themes/Theme";

export const StyledWrapper = styled.div`
  box-sizing: border-box;
  height: 34px;
  width: fit-content;
  display: flex;
  align-items: center;
  color: ${props => props.active ? "rgb(37, 194, 160)" : (props.isInDropdown ? "#1C1E21" : appTheme.textColor)};
  padding: 4px 16px;
  font-weight: 500;
  :hover {
    color: rgb(37, 194, 160);
    cursor: pointer;
  }
`;
